var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-autocomplete",
    _vm._b(
      {
        class: { "ap__no-label": _vm.hideLabel },
        attrs: {
          items: _vm.values,
          disabled: _vm.disabled,
          "item-text": "name",
          "item-value": "id",
          "return-object": "",
          "hide-details": "",
          dense: _vm.hideLabel,
        },
        model: {
          value: _vm.value,
          callback: function ($$v) {
            _vm.value = $$v
          },
          expression: "value",
        },
      },
      "v-autocomplete",
      _vm.labelProps,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }